import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceGroupInfo';
export const useSourceGroupInfoTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Как это работает',
    content:
      'Все источники в группе по умолчанию наследуют следующие настройки группы: параметры источников, список видеоаналитик, параметры видеоаналитик. В конкретном источнике можно изменить настройки. Эти значения будут приоритетнее групповых',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'How it works',
    content:
      'All sources in the group inherit the following group settings by default: source parameters, the list of video analytics, video analytics parameters. Settings can be changed for a specific source. Those values take precedence over group values',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Cómo funciona',
    content:
      'Todas las fuentes del grupo heredan por defecto la siguiente configuración del grupo: parámetros de fuentes, lista de videoanalíticas, parámetros de videoanalíticas. La configuración se puede cambiar para una fuente concreta. Estos valores tienen prioridad sobre los valores del grupo',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Como funciona',
    content:
      'Todas as fontes do grupo herdam por padrão as seguintes configurações do grupo: parâmetros de fontes, lista de videoanalíticas, parâmetros de videoanalíticas. As configurações podem ser alteradas para uma fonte específica. Esses valores têm prioridade sobre os valores do grupo',
  },
}) as Record<string, unknown>;
